<script>
	// Stores
	import NoteStore from '@/Stores/User/NoteStore.js';
	// Components
	import Modal from '@/Components/ModalFlex.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import TextAreaInput from '@/Components/TextAreaInput.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';
	import { UserNoteCategories, UserNoteCategoryNames } from '@/Constants/UserNotes.js';
	import SelectInput from '@/Components/SelectInput.svelte';

	export let open = false;
	export let user;
	export let onSave;

	let sending = false;
	let note = '';
	let category = UserNoteCategories.TRADING;

	$: open && (note = '');

	function confirmClicked() {
		if (!note) return;
		sending = true;
		NoteStore.saveUserNote(user.id, note, category)
			.then(() => {
				notify({
					type: 'success',
					title: 'Note Saved',
					message: 'The note was saved.',
					timeout: 3
				});
				onSave();
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Problem with note',
					message: e.error[0] || 'Problem saving note',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
				open = false;
			});
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Add Note</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<!-- Dropdown for category -->
			<label class="mb-1 text-left font-semibold">Category</label>
			<SelectInput className="py-2 w-full" name="category" bind:value={category} required={true}>
				{#each Object.entries(UserNoteCategoryNames) as [key, label]}
					<option value={key}>{label}</option>
				{/each}
			</SelectInput>

			<!-- Note textarea -->
			<label class="mb-1 text-left font-semibold">Note</label>
			<TextAreaInput name="note" className="pb-4 w-full" bind:value={note} required={true} placeholder="Description" />
			<LoadingButton on:click={confirmClicked} loading={sending} className="mb-4 btn btn-primary">Save</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}> Cancel </button>
		</div>
	</Modal>
{/if}
